export default __webpack_public_path__ + "static/media/gallery_17.73342488.jpg";